import React, { useEffect, useState, useCallback } from "react";
import { CommonPropertyProps, ElementType } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import { useTranslation } from "react-i18next";
import { SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps;
	elements?: ElementType[];
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	elements,
	validation,
	elementIndex,
}: Props) => {
	const { t } = useTranslation();
	const [searchFields, setSearchFields] = useState<SearchSelectOptionProps[]>(
		[]
	);

	const getSearchFields = useCallback(() => {
		// Gets list of entities with the field path passed
		if (elements) {
			const tempSearchFields: SearchSelectOptionProps[] = [];
			let found = false;

			// Create new search field list and mark if current value is in there
			elements.forEach(element => {
				if (element.name !== undefined) {
					tempSearchFields.push({
						value: element.name,
						label: element.name,
					});
					if (
						value !== null &&
						value !== undefined &&
						value.value === element.name
					)
						found = true;
				}
			});
			setSearchFields(tempSearchFields);
			// If current value was not found in list then delete value
			if (!found)
				updateStore({
					elementIndex,
					property: field,
					value: null,
				});
		} else if (searchFields.length > 0) {
			setSearchFields([]);
			if (value !== null && value !== undefined)
				updateStore({
					elementIndex,
					property: field,
					value: null,
				});
		}
	}, [
		elementIndex,
		elements,
		field,
		searchFields.length,
		updateStore,
		value,
	]);

	useEffect(() => {
		getSearchFields();
	}, [getSearchFields, elements]);

	const props = {
		updateStore,
		field,
		required,
		value,
		validation,
		desc,
		elementIndex,
		options: searchFields,
		disabled: searchFields.length && elements ? false : true,
		disabledPlaceholder: t("formDesigner.placeholders.searchFieldRelation"),
	};

	return <SearchSelectContainer {...props} />;
};
